'use client';

const AUTH_SESSION_HINT_KEY = 'authSessionHint';

export const setAuthSessionHint = (wasLoggedIn: boolean) => {
  try {
    localStorage.setItem(AUTH_SESSION_HINT_KEY, wasLoggedIn ? '1' : '0');
  } catch {
    return;
  }
};

export const getAuthSessionHint = (): boolean => {
  try {
    return localStorage.getItem(AUTH_SESSION_HINT_KEY) === '1';
  } catch {
    return false;
  }
};

export const removeAuthSessionHint = () => {
  try {
    localStorage.removeItem(AUTH_SESSION_HINT_KEY);
  } catch {
    return;
  }
};
